export class InputTimeoutVO extends Phaser.Events.EventEmitter {
  constructor(scene, { vo, timeout, enabled, disableOnInput }) {
    super();
    this.scene = scene;
    this.vo = vo;
    this.timeout = timeout || 15000;
    this.enabled = false;
    this.disableOnInput = disableOnInput;
    if (enabled) this.enable();
  }

  enable() {
    if (this.enabled) return;

    this.enabled = true;

    this.timer = this.scene.time.addEvent({
      delay: this.timeout,
      callback: () => {
        this.scene.game.trackPromptStart();
        this.scene.game.vo.play(this.vo);
        this.emit('prompt');
      },
      loop: true,
    });

    if (this.disableOnInput) this.scene.input.on('pointerdown', this.disable, this);
  }

  disable() {
    this.scene.game.trackPromptStop();
    this.enabled = false;
    if (this.timer) {
      this.timer.remove();
      this.timer = null;
    }
    this.scene.input.off('pointerdown', this.disable, this);
  }

  destroy() {
    this.disable();
    this.scene = null;
    this.vo = null;
    this.timeout = null;
    this.disableOnInput = null;
    this.enabled = null;
  }
}
